import React, { useState, useEffect } from 'react';
import { Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { validateNumericCell } from '../common/ExcelTableComponents';
import { putData, fetchData } from '../common/Api';
import { useHistory } from 'react-router-dom';
import { useSpace } from '../common/SpaceContextProvider';
import InfoIcon from '@mui/icons-material/Info';
import AlertCustom from '../common/AlertCustom';


const ShirtInput = ({ value, onChange, index }) => {
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
        setInputValue(value); // Reset when parent state changes
    }, [value]);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        onChange(index, e.target.value); // Notify parent of changes
    };

    return (
        <input
            className="shirts-list-item-input"
            type="text"
            value={inputValue}
            onChange={handleInputChange}
        />
    );
};

const ShirtsTab = ({ id }) => {

    const history = useHistory();
    const [data, setData ] = useState([]);
    const [serverData, setServerData ] = useState([]);
    const [emptyMatrix, setEmptyMatrix ] = useState([]);
    const [error, setError] = useState(null);
    const { shirts, setShirts} = useSpace();
    const [showAlert, setShowAlert] = useState(false);

    const tooltip = (
        <Tooltip id="shirts-tab-tooltip">
            Allocate the required time (in months) for each shirt size. 
            Enter the number of months needed to plan and produce resources accordingly.
        </Tooltip>
      );

    const getData = async () => {
        try {
            const response = await fetchData(`/api/v1/spaces/${id}/shirts`);
            const data = await response.data;
            const result = data.map(element => {
                        element.className = "";
                        element.error = "";
                        return element;
                    });
            setData(JSON.parse(JSON.stringify(result)));
            setShirts(JSON.parse(JSON.stringify(result)));
            setServerData(JSON.parse(JSON.stringify(result)));
            
            const empty = Array(result.length).fill().map((element, index) =>  (
                {id: result[index].id, name:  result[index].name, 
                    className: "",  error: "", resource_mos: 0}));
            
            setEmptyMatrix(JSON.parse(JSON.stringify(empty)));

        } catch (error) {
            setError(error);
        }
    }

    useEffect(() => {
        const fetchShirtsData = async () => {
            await getData();
        }
        fetchShirtsData();
    }, []);


    const handleLoadTestData = async () => {
        try {
            const response = await fetch('/shirts.json');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const testData = await response.json();

            const newData = [];
            shirts.map((element) => {
                const matchedInd = testData.findIndex((target) => target.name === element.name);
                const newElement = {...element, resource_mos: testData[matchedInd].resource_mos };
                newData.push(matchedInd < 0 ? element : newElement);
            });

            setData(JSON.parse(JSON.stringify(newData)));
            setShirts(JSON.parse(JSON.stringify(newData)));

        } catch (error) {
            console.error(error)
        }
    };

    useEffect(()=> {
        if (error) {
            alert(`Error loading shirts :: ${error.message}`);
            if (error.status === 401){
                history.push('/login');
            }
            setError(null);
        }
      }, [error]);

    const handleChange = ( e ) => {
        
        const index = e.target.id;

        if (validateNumericCell(e.target.value)) {
            setData((prevData) => {
                const newValue = Number(e.target.value);
                const newData = prevData.map((item, i) =>
                    i === index ? { ...item, 
                        resource_mos: newValue, 
                        className: '', 
                        error: '' } : item
                );
                return newData;
            });
        } else {
            setData((prevData) => {
                const newData = prevData.map((item, i) =>
                    i === index ? { ...item, 
                        className: 'invalid-input', 
                        error: 'Invalid format of the input value.' } : item
                );
                return newData;
            });
        }
    };

    const saveData = async () => {
        console.log("saving data", data)
        try {
            await putData(`/api/v1/spaces/${id}/shirts`, data);
            setShirts(JSON.parse(JSON.stringify(data)));
            setServerData(JSON.parse(JSON.stringify(data)));
            setShowAlert(false);
            // set data somehow here doesnt work properly...
        } catch (error) {
            alert(`Error saving data :: ${error.message}`);
        }
    }

    useEffect(() => { 
        if (JSON.stringify(data) !== JSON.stringify(serverData)){
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }
    }, [data, serverData]);
    
    return (
        <div className='tab-container'>

            <div className='tab-container-main-panel'>
            <div style={{margin: "1rem 0rem"}}>
            {
                data.map((element, key) => 
                    <div key={`form-group-${key}`} className='shirts-list-item' >
                        <div className='shirts-list-item-background'>
                            <div className='shirts-list-item-label'>
                                <label style={{fontWeight: "600"}}>
                                    {element.name}
                                </label>
                            </div>
                            <div className='shirts-list-item-input-div'>
                            <ShirtInput
                                value={element.resource_mos}
                                onChange={(index, newValue) => {
                                    handleChange({target: {id: index, value: newValue}});
                                }}
                                index={key}
                            />
                            </div>
                        </div>
                    </div>
                )
            }
            
            </div>

            <div className='btn-group-custom'>
                <button className='btn-custom green' 
                    onClick={() => saveData()}>Save
                </button> 
                <button className="btn-custom blue" 
                    onClick={() => setData(emptyMatrix)} 
                    variant="secondary" >Clear All Data
                </button>
                <AlertCustom 
                    text="Shirts data not saved" 
                    variant="danger"
                    showAlert={showAlert}
                    setShowAlert={setShowAlert}
                />
                { error ? <p style={{margin: "0px"}}>{error}</p> : null }
            </div>

            <div className='m-2'>
            <Form.Text className="text-muted">
                Upload example data <span onClick={() => handleLoadTestData()} className="underlined-text">here</span>. 
            </Form.Text> 
            </div>

        </div>

        <div className='switch-list-table-view-container'>
            <OverlayTrigger placement="bottom" overlay={tooltip}>
                <div className='icon-container'>
                    <InfoIcon className='switch-view'></InfoIcon>
                </div>
            </OverlayTrigger>
        </div>

        </div>
    )
}

export default ShirtsTab;